<template>

 <div>
	 <v-dialog title="修改课时有效期" v-model="hideShow" width="600px" persistent scrollable>
		<v-card class="fc-dialog-card">
			<v-card-title class="fc-dialog-header"><span class="fc-dialog-symbol"><v-icon color="#d9363e" size="24">mdi-calendar-edit</v-icon></span><div><h2>修改课时有效期</h2><p>核对学员账户，选择新的有效期</p></div><v-spacer /><v-btn icon aria-label="关闭修改课时有效期" @click="cancel"><v-icon size="22">mdi-close</v-icon></v-btn></v-card-title>

			<v-card-text class="fc-dialog-body">

				<v-row dense v-if="account" class="">
					<v-col cols="6">
						<v-text-field label="学员姓名" v-model="account.studentName" disabled dense outlined color="#d9363e" aria-label="学员姓名"></v-text-field>
					</v-col>
					<v-col cols="6">
						<v-text-field label="课程名称" v-model="account.courseName" disabled dense outlined color="#d9363e" aria-label="课程名称"></v-text-field>
					</v-col>
					<v-col cols="6">
						<v-text-field label="课时余额" v-model="account.balanceHour" disabled dense outlined color="#d9363e" aria-label="课时余额"></v-text-field>
					</v-col>
					<v-col cols="6">
						<v-text-field label="金额余额" v-model="account.balanceFee" disabled dense outlined color="#d9363e" aria-label="金额余额"></v-text-field>
					</v-col>

					<v-col cols="12" class="">
						<v-text-field label="原有效期" disabled v-model="account.expireDate" dense outlined color="#d9363e" aria-label="原有效期"></v-text-field>
						<v-menu ref="menu1" v-model="menu1" :close-on-content-click="false"
							transition="scale-transition" offset-y min-width="auto">
							<template v-slot:activator="{ on, attrs }">
								<v-text-field v-model="form.expireDate" label="新有效期" readonly v-bind="attrs" v-on="on"
									dense clearable outlined color="#d9363e" aria-label="新有效期"></v-text-field>
							</template>
							<v-date-picker v-model="form.expireDate" @input="menu1=false" no-title scrollable locale="zh-cn" color="#d9363e">
							</v-date-picker>
						</v-menu>
					</v-col>
				</v-row>
			</v-card-text>
			<v-card-actions class="fc-dialog-actions">
				<v-spacer></v-spacer>
				<v-btn @click="cancel" outlined color="#65758c">取消</v-btn>
				<v-btn @click="submitForm" :disabled="form.submitting" :loading="form.submitting" depressed class="fc-confirm" color="#d9363e">确定</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
 </div>

</template>

<script>
	import utils from "../config/utils"
	export default {
		name:"edit-account-expire",
		props: {
			//显示/隐藏。
			show: {
				type: Boolean,
				default: false
			},
			account:{
				type:Object,
				default:null
			}
		},
		watch:{
			show(newVal,oldVal){
			
				this.hideShow = newVal;
				if(this.hideShow){
					this.form.expireDate = "";
					this.form.submitting = false;
					this.menu1 = false;
				}
			}
		},
		data(){
			return {
				menu1:false,
				shopId:"",
				hideShow:this.show,
				currentCourseId:"",
				form:{
					submitting:false,
					expireDate:"" , 
				},
			}
		},
		
		mounted() {
			console.log("mounted");
			this.shopId = utils.getCurrentShopId();
		},
		methods:{
			cancel(){
				this.$emit("cancel","");
			},
			
			async submitForm(){
				if(this.form.submitting) return;
				if(!this.form.expireDate){
					this.$noty.error('有效期不能为空');
					return;
				}
				this.form.submitting = true;
				try {
					const url = `/financial/course/account/expire/${this.account.id}/${this.form.expireDate}`;
					const res = await this.axios.post(url);
					if (res && res.data && res.data.code === 200) {
						this.$noty.success("修改成功");
						this.$emit("success", "");
					} else {
						this.$noty.error((res && res.data && res.data.message) || '修改失败，请稍后重试');
					}
				} catch (error) {
					this.$noty.error('修改失败，请检查网络后重试');
				} finally {
					this.form.submitting = false;
				}
			},
			
		}
	}
	
</script>

<style lang="scss" scoped src="../assets/styles/course-account-dialog.scss"></style>
